import {Stack, Typography} from "@mui/material";
import {useParams} from "react-router-dom";
import {UserCompaniesTable} from "./UserCompaniesTable";
import {useActiveUserMembershipItems} from "../../hooks/activeUserMembershipItemsHooks";

export const UserCompaniesView: React.FC = () => {
    const {userId} = useParams();
    const companyItemsState = useActiveUserMembershipItems();

    return (
        <>
            <Stack direction="column">
                <Stack direction="row" height="4rem" alignItems="center" justifyContent="space-between">
                    <Typography fontSize={20} fontWeight={500} textTransform="uppercase">
                        Companies
                    </Typography>
                </Stack>
                <UserCompaniesTable
                    userId={userId}
                    memberships={companyItemsState.companyItems}
                    isLoading={companyItemsState.isLoading}
                    refreshCompanies={companyItemsState.refresh}
                />
            </Stack>
        </>
    );
};
